import { render, staticRenderFns } from "./pieTable.vue?vue&type=template&id=18c6f961&scoped=true"
import script from "./pieTable.vue?vue&type=script&lang=js"
export * from "./pieTable.vue?vue&type=script&lang=js"
import style0 from "./pieTable.vue?vue&type=style&index=0&id=18c6f961&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c6f961",
  null
  
)

export default component.exports